export const CITIES = ['Brossard', 'Windsor'] as const
export type City = (typeof CITIES)[number]

/**
 * Mirror of the city selected in the header, for pure helpers (ATNA,
 * audience estimates) that run outside React. Kept in sync by CityProvider.
 */
let activeCity: City = 'Brossard'

export function setActiveCity(city: City) {
  activeCity = city
}

export function getActiveCity(): City {
  return activeCity
}
